module.exports = __webpack_public_path__ + "img/sieckFinesseAdaptation5.786b6361.png";